export type ChecklistCategory =
  | 'daily_inspection'
  | 'trip_start'
  | 'trip_end'
  | 'weekly'
  | 'monthly'
  | 'custom';

export type ItemType = 'ok_nok' | 'ok_nok_na' | 'text' | 'number' | 'photo_required';

export interface ChecklistTemplateItem {
  id: string;
  label: string;
  description: string | null;
  type: ItemType;
  required: boolean;
  photoRequired: boolean;
  sortOrder: number;
  group: string | null;
}

export interface ChecklistTemplate {
  id: string;
  name: string;
  description: string | null;
  category: ChecklistCategory;
  isActive: boolean;
  version: number;
  items: ChecklistTemplateItem[];
  createdAt: string;
  updatedAt: string;
}

export interface ChecklistExecution {
  id: string;
  templateId: string;
  vehicleId: string;
  driverId: string | null;
  executedBy: string;
  status: 'in_progress' | 'completed' | 'cancelled';
  odometerMeters: number | null;
  startedAt: string;
  completedAt: string | null;
  totalItems: number;
  okCount: number;
  nokCount: number;
  naCount: number;
  createdAt: string;
  items?: ChecklistExecutionItem[];
  template?: { id: string; name: string; category: ChecklistCategory } | null;
  vehicle?: { id: string; plate: string; brand: string | null; model: string | null } | null;
  executor?: { id: string; name: string; email: string; role: string } | null;
  driver?: { id: string; name: string; cnhCategory: string } | null;
}

export interface ChecklistExecutionItem {
  id: string;
  templateItemId: string;
  label: string;
  type: string;
  response: 'ok' | 'nok' | 'na' | null;
  observation: string | null;
  answeredAt: string | null;
}

export interface TemplatesListResponse {
  data: ChecklistTemplate[];
  meta: { page: number; limit: number; total: number };
}

export interface ExecutionsListResponse {
  data: ChecklistExecution[];
  meta: { page: number; limit: number; total: number };
}

export const CATEGORY_LABELS: Record<ChecklistCategory, string> = {
  daily_inspection: 'Inspeção diária',
  trip_start: 'Início de viagem',
  trip_end: 'Fim de viagem',
  weekly: 'Semanal',
  monthly: 'Mensal',
  custom: 'Personalizado',
};

export const ITEM_TYPE_LABELS: Record<ItemType, string> = {
  ok_nok: 'OK / NOK',
  ok_nok_na: 'OK / NOK / N/A',
  text: 'Texto livre',
  number: 'Numérico',
  photo_required: 'Foto obrigatória',
};
